import { Component, OnDestroy, OnInit, signal } from '@angular/core'
import { Subject, takeUntil, throttleTime } from 'rxjs'
import { AppPaths } from 'src/app/app-routing.module'
import { AppStateService } from 'src/app/core/services/app-state.service'
import { format } from 'date-fns'

@Component({
  selector: 'app-customer-history-control',
  templateUrl: './customer-history-control.component.html',
  standalone: false,
})
export class CustomerHistoryControlComponent implements OnInit, OnDestroy {
  public appPath = AppPaths.Customer
  public currentDate: Date | undefined
  public isLoading = signal(false)
  private cleanUp$ = new Subject<void>()

  constructor(private appState: AppStateService) { }

  ngOnInit(): void {
    this.currentDate = this.appState.selectTimestamp() ?? new Date()
    this.currentDate?.setHours(0, 0, 0, 0)

    this.appState.stateChanged.pipe(takeUntil(this.cleanUp$)).subscribe(() => {
      this.evaluateQueryParameters()
    })

    this.appState.isLoadingChanged$
      .pipe(
        throttleTime(1000, undefined, { leading: true, trailing: true }),
        takeUntil(this.cleanUp$),
      )
      .subscribe((isLoading) => {
        this.isLoading.set(isLoading)
      })

    this.updateQueryParameters()
  }

  ngOnDestroy(): void {
    this.appState.setState(this.appPath, { timestamp: undefined })
    this.cleanUp$.next()
    this.cleanUp$.complete()
  }

  handleOnTimestampChanged = (timestamp: Date) => {
    this.currentDate = timestamp
    this.currentDate.setHours(0, 0, 0, 0)
    this.updateQueryParameters()
  }

  updateQueryParameters() {
    this.appState.setState(this.appPath, {
      timestamp: this.currentDate
        ? format(this.currentDate, "yyyy-MM-dd'T'HH:mm:ss'Z'")
        : undefined,
    })
  }

  evaluateQueryParameters() {
    if (this.appState.hasDatasourceParamChanged()) {
      this.updateQueryParameters()
    }
  }
}
